import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useAddKarteCommentCache } from "../../../../hooks/http/useFetchKarte";
import { useUpdateSectionKartesCache } from "../../../../hooks/http/useFetchSectionKartes";
import { useUpdateStudentKartesCache } from "../../../../hooks/http/useFetchStudentKartes";

interface Props {
  karteId: string;
  studentId: string;
  sectionId: string;
}

export const useCreateKarteComment = ({
  karteId,
  studentId,
  sectionId,
}: Props) => {
  const { addKarteCommentCache } = useAddKarteCommentCache({
    studentId,
    karteId,
  });
  const { addKarteCommentCache: addKarteCommentToSectionCache } =
    useUpdateSectionKartesCache();
  const { addKarteCommentCache: addKarteCommentToStudentCache } =
    useUpdateStudentKartesCache();

  return useBoronMutation(
    async (params: { name: string; comment: string }) =>
      await boronClient.POST(
        "/api/v1/students/{student_id}/kartes/{karte_hashid}/comments",
        {
          params: {
            path: {
              student_id: studentId,
              karte_hashid: karteId,
            },
          },
          body: {
            karte_comment: params,
          },
        },
      ),
    {
      onSuccess: ({ karteComment }) => {
        // 個別カルテキャッシュを更新
        addKarteCommentCache(karteComment);
        // 校舎カルテ一覧キャッシュを更新
        addKarteCommentToSectionCache(sectionId, karteId, karteComment);
        // 生徒カルテ一覧キャッシュを更新
        addKarteCommentToStudentCache(studentId, karteId, karteComment);
      },
    },
  );
};
